/**
 * Only what the screens a Brazilian business reaches in the legacy app render
 * (Business Info, Manage Team, Branded Coin, Offer details). Anything missing
 * falls back to en-US through `fallbackLocale`.
 */
export default {
  buttons: {
    save: 'Salvar',
    back: 'Voltar',
    next: 'Próximo',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    continue: 'Continuar',
    submitting: 'Enviando...',
    loading: 'Carregando...',
    retry: 'Tentar novamente',
    saveChanges: 'Salvar alterações'
  },
  alerts: {
    fieldsError: 'Confira os campos destacados abaixo',
    highlightedItemsError: 'Confira os campos destacados abaixo',
    businessLoadError:
      'Não foi possível carregar as informações do seu negócio. Atualize a página e tente novamente.'
  },
  pluralize: {
    coin: 'Coin | Coins',
    member: 'membro | membros',
    day: 'dia | dias',
    offer: 'Mimo | Mimos',
    week: 'semana | semanas',
    month: 'mês | meses',
    year: 'ano | anos'
  },
  components: {
    inputWrapper: {
      optional: 'Opcional'
    },
    table: {
      empty: 'Não há resultados para mostrar.'
    },
    groupedLocationsByCity: {
      redemptions: 'Resgates: {count}'
    },
    socialMediaButton: {
      copyLink: 'Copiar link',
      more: 'Mais'
    },
    socialShareButton: {
      linkCopied: 'Link copiado.'
    },
    colorPicker: {
      label: 'Escolha uma cor'
    },
    coinCustomizationForm: {
      title: 'Personalize sua Coin',
      borderColorLabel: 'Escolha a cor da borda'
    },
    customSelect: {
      loading: 'Carregando...',
      empty: 'Nenhum resultado para mostrar.',
      apply: 'Aplicar',
      clearFilters: 'Limpar filtros',
      search: 'Buscar'
    },
    dropDownLocations: {
      all: 'Todas',
      allLocations: 'Todas as unidades',
      locations: 'Unidades',
      addMoreLater: 'Você pode adicionar mais unidades depois.'
    },
    cropModal: {
      backgroundColor: 'Cor de fundo',
      white: 'Branco',
      black: 'Preto'
    },
    selectDropdownField: {
      optional: 'Opcional',
      multiselect: {
        placeholder: 'Selecione uma opção',
        tagPlaceholder: 'Pressione Enter para criar uma tag',
        selectLabel: 'Pressione Enter para selecionar',
        selectGroupLabel: 'Pressione Enter para selecionar o grupo',
        selectedLabel: 'Selecionado',
        deselectLabel: 'Pressione Enter para remover',
        deselectGroupLabel: 'Pressione Enter para desmarcar o grupo',
        noOptions: 'A lista está vazia.',
        noResult: 'Nenhum item encontrado. Tente buscar de outro jeito.'
      }
    },
    interactiveCoin: {
      btnNextLabel: 'Próximo',
      btnSaveLabel: 'Salvar',
      errorImgUpload: 'Não foi possível enviar as imagens. Tente novamente.',
      errorReserveInfos:
        'Não foi possível salvar as informações da Coin. Tente novamente.',
      errorNameUnavailable:
        'Esse nome de Coin não está disponível. Escolha outro nome e tente novamente.',
      errorGeneral: 'Ops, algo deu errado. Tente novamente.'
    },
    imageUploadBlock: {
      uploadFailed: 'Falha no envio',
      retryUpload: 'Tentar novamente',
      label: 'Envie seu logo ou uma imagem',
      edit: 'Editar',
      click:
        '<span class="btn">Clique para enviar</span> ou<br/>arraste e solte a imagem aqui',
      formatAcceptable: 'São aceitos arquivos JPEG ou PNG.',
      helpText:
        'Use um arquivo JPEG, PNG ou SVG. Recomendamos no mínimo 420 x 420 px e até 5 MB.',
      warnFormatFile: 'Selecione uma imagem no formato correto: JPEG ou PNG.',
      warnMaximumFileSize: 'O tamanho máximo do arquivo é 10 MB.',
      warnMaximumFileSize5: 'O tamanho máximo do arquivo é 5 MB.',
      maximumFileSizeLabel: 'Até 10 MB.',
      cropTitleDefault: 'Ajuste sua imagem'
    },
    phoneInput: {
      placeholderSearch: 'Busque seu país',
      optional: 'Opcional',
      title: 'Selecione o país'
    }
  },
  validations: {
    fields: {
      businessName: {
        required: 'Informe o nome do negócio'
      },
      phone: {
        required: 'Informe um telefone'
      },
      phone_input: {
        required: 'Informe um telefone'
      },
      category: {
        required: 'Selecione uma categoria'
      },
      website: {
        required: 'Informe um endereço',
        url: 'Informe um endereço válido'
      },
      instagram: {
        url: 'Informe um endereço válido do Instagram'
      },
      facebook: {
        url: 'Informe um endereço válido do Facebook'
      },
      name: {
        required: 'Informe um nome'
      },
      email: {
        required: 'Informe um e-mail',
        email: 'Informe um e-mail válido'
      },
      image: {
        required_image: 'Escolha uma imagem'
      },
      color: {
        required: 'Escolha uma cor'
      }
    }
  },
  signIn: {
    accountAlreadyActive:
      'Sua conta já está ativa. Entre com seu e-mail e senha.'
  }
};
